import { Locales } from 'constants/app.constant';

export const LocaleOptions = Object.values(Locales).map((localeOption) => ({ id: localeOption, name: localeOption, value: localeOption }));
